export default {
  background: "#161F3B",
  primary: "#242E4C",
  secondary: "#1C2540",
  third: "#F76FAF",
  text: "#EBEBF2",
};
